import { useMutation, useQueryClient } from '@tanstack/react-query';

import { deleteTimeOffTypeChange } from '../../api/time-off-changes.api';
import { TIME_OFF_TYPE_CHANGES_QUERY_KEY_ROOT } from './use-time-off-type-changes';
import { TIME_OFF_TYPE_DETAIL_QUERY_KEY } from './use-time-off-type-details';
import { TIME_OFF_TYPES_QUERY_KEY } from './use-time-off-types';

interface DeleteTimeOffTypeChangeParams {
  typeId: number;
  changeId: number;
}

export const useDeleteTimeOffTypeChange = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: ({ typeId, changeId }: DeleteTimeOffTypeChangeParams) =>
      deleteTimeOffTypeChange({ typeId, changeId }),
    onSuccess: async (_, { typeId }) => {
      await queryClient.invalidateQueries({ queryKey: TIME_OFF_TYPE_CHANGES_QUERY_KEY_ROOT });
      await queryClient.invalidateQueries({ queryKey: TIME_OFF_TYPE_DETAIL_QUERY_KEY(typeId) });
      await queryClient.invalidateQueries({ queryKey: TIME_OFF_TYPES_QUERY_KEY });
    },
  });
};
